import { Box, Typography } from "@material-ui/core";
import { FiDownload } from "react-icons/fi";

import { COLORS } from "../../../../theme/colors";
import { MEDIA_SERVICE_FILES_BASE_URL } from "../../../../services/api";
import { DEFAULT_TEMPLATE_FILE } from "../../../aroundtown/PortfolioRegistrationPage";

export const DownloadTeamplateStep = ({
  downloadText = "download the template",
  templateFile = DEFAULT_TEMPLATE_FILE,
  onClick,
}) => {
  return (
    <Box borderRadius={8} bgcolor={COLORS.darks[0][10]} height="100%" minHeight={300}>
      <Box margin="auto" width="fit-content" pt={10} pb={5}>
        <FiDownload style={{ color: COLORS.purple, fontSize: 60 }} />
      </Box>
      <Typography variant="h4" align="center">
        To start,{" "}
        {onClick ? (
          <span style={{ color: COLORS.purple, cursor: "pointer" }} onClick={onClick}>
            {downloadText}
          </span>
        ) : (
          <a
            style={{ textDecoration: "none", color: COLORS.purple }}
            href={`${MEDIA_SERVICE_FILES_BASE_URL}/${templateFile}`}
            onClick={(event) => {
              if (onClick) {
                event.preventDefault();
              }
            }}
          >
            {downloadText}
          </a>
        )}{" "}
        and fill it out
      </Typography>
    </Box>
  );
};
